import { createApp } from 'vue';
import Chat from './ChatDialog.vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';

// 引入全局注册的内容
import SvgIcon from '@/components/globalComponents/icons/SvgIcon.vue';
import router from '@/router';

let app = undefined; //定义挂载节点
let mountNode = undefined; //挂载点内容
let componentId = 'ChatComponent'; //创建组件的id

/**
 * 创建弹窗消息组件
 * @param {type Boolean，是否显示对话窗口，true为显示，false为不显示} dialogVisible 
 */
export function createChat(dialogVisible = true) {
    app = createApp(Chat, {
        dialogVisible
    });

    if(document.querySelector('#ChatComponent')){
        return false;
    }

    app.use(ElementPlus,{
        locale: zhCn
    });

    // 1.注入路由
    app.use(router);

    // 2.注册全局 svg-icon 组件    
    app.component('SvgIcon', SvgIcon);

    mountNode = document.createElement('div');
    let attr = document.createAttribute('id'); //创建节点属性方便在销毁组件的时候做判断
    attr.value = componentId;
    mountNode.setAttributeNode(attr);
    document.body.appendChild(mountNode);
    app.mount(mountNode);
}

//销毁组件
export function destroyChat() {
    if (app !== undefined && mountNode !== undefined) {
        app.unmount(mountNode);//卸载挂载节点
        document.querySelector("#" + componentId).remove();//删除挂载点
        //清空挂载点及挂载内容
        app = mountNode = undefined;
    }
}